"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorizationContext = void 0;
const tslib_1 = require("tslib");
const enums_1 = require("./enums");
const Serializable_1 = require("./Serializable");
const decorators_1 = require("../decorators");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
/**
 * This class describes the authenticated user and their authorizations in a uniform way.
 * It's designed to tranform to headers and AWS requestContexts, so they may only contain strings
 */
class AuthorizationContext extends Serializable_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsIn)(Object.values(enums_1.Brand)),
    (0, decorators_1.Docs)({ example: enums_1.Brand.ESSENT, description: 'The brand which the request was made for' }),
    tslib_1.__metadata("design:type", String)
], AuthorizationContext.prototype, "brand", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)({ name: 'online-account-id' }),
    (0, decorators_1.Docs)({
        example: '01202031023',
        description: 'The online account id of the user, if a user context exists',
    }),
    tslib_1.__metadata("design:type", String)
], AuthorizationContext.prototype, "onlineAccountId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)({ name: 'account-id' }),
    (0, decorators_1.Docs)({ example: '0100087729', description: 'The SAP account id (BPID) of the customer' }),
    tslib_1.__metadata("design:type", String)
], AuthorizationContext.prototype, "accountId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)({ name: 'employee-id' }),
    (0, decorators_1.Docs)({ example: 'A012345', description: 'The employee id (KID) of the employee' }),
    tslib_1.__metadata("design:type", String)
], AuthorizationContext.prototype, "employeeId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)({ name: 'legacy-employee-id' }),
    (0, decorators_1.Docs)({ example: 'UI123456', description: 'The legacy employee id (UI) of the employee' }),
    tslib_1.__metadata("design:type", String)
], AuthorizationContext.prototype, "legacyEmployeeId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)({ name: 'client-id' }),
    (0, decorators_1.Docs)({
        example: '00000000-0000-0000-0000-000000000000',
        description: 'The plain client_id of the oAuth client used.',
    }),
    tslib_1.__metadata("design:type", String)
], AuthorizationContext.prototype, "clientId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)({ name: 'x-api-key' }),
    (0, decorators_1.Docs)({
        example: '00000000-0000-0000-0000-000000000000',
        description: 'The api key for this request, may be derived from clientId',
    }),
    tslib_1.__metadata("design:type", String)
], AuthorizationContext.prototype, "apiKey", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)({ name: 'oidc-scope' }),
    (0, decorators_1.Docs)({
        example: 'Customer.Read Customer.Write',
        description: 'Space separated oAuth scopes of the auth token',
    }),
    tslib_1.__metadata("design:type", String)
], AuthorizationContext.prototype, "oidcScopes", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)({ name: 'user-scope' }),
    (0, class_validator_1.IsIn)(Object.values(enums_1.UserScope)),
    (0, decorators_1.Docs)({
        example: enums_1.UserScope.EMPLOYEE,
        description: 'Space separated oAuth scopes of the auth token',
    }),
    tslib_1.__metadata("design:type", String)
], AuthorizationContext.prototype, "userScope", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)({ name: 'principal-id' }),
    (0, decorators_1.Docs)({
        example: '231234123',
        description: 'The principal id on whose behalf the request was made',
    }),
    tslib_1.__metadata("design:type", String)
], AuthorizationContext.prototype, "principalId", void 0);
exports.AuthorizationContext = AuthorizationContext;
